function freezeScroll() {
    const elementsToScroll = $(".js-allow-scroll, .modal");

    setTimeout(() => {
        elementsToScroll.each(function() {
            const $elem = $(this);

            bodyScrollLock.disableBodyScroll($elem[0], {
                reserveScrollBarGap: true
            });
        });
    }, 1);

    $('html, body').addClass('freeze-page');
}

function unfreezeScroll() {
    $('html, body').removeClass('freeze-page');
    bodyScrollLock.clearAllBodyScrollLocks();
}

function showOverlay(time = 250, allowScroll = false) {
    $('.c-overlay').addClass('is-active');

    if (!allowScroll) {
        freezeScroll();
        $('body').addClass('is-overlayed');
    }
}

function hideOverlay(time = 250) {
    $('body').removeClass('is-overlayed');
    $('.c-overlay').removeClass('is-active');

    unfreezeScroll();
}
